import { connect } from 'react-redux';

import { IMagazineProps, Magazine } from './Magazine';
import { IState } from '../../store';

export const mapStateToProps = ({ magazine }: IState): IMagazineProps => ({ magazineList: magazine });

export const MagazineContainer = connect<IMagazineProps>(mapStateToProps)(Magazine);
